export async function ptlShowOrderInfoUseCase(id, shipmentRepository) {
    
    const result = await shipmentRepository.ptl_show_order_info(id);
    
    const entity = new shipmentRepository.model_ptl_show(result.data.success.arguments);
    
    if (!entity.isValid()) {
        throw new Error("Shipment ptl inválido");
    }

    return entity;
}